/* eslint-disable react/jsx-key */
import React from 'react';
import styled, { css } from 'styled-components';
import { IShadowProps } from '../../fundamentals/shadows/shadows';
import { EORA_SPACES, IGutterProps } from '../../fundamentals/spaces/space';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { MATERIAL_ICONS, MaterialIcon, MaterialIconType } from '../../components/Icon/icons';
import { Icon } from '../../components/Icon/Icon';
import { STATUS_COLOURS, StatusColour } from '../../fundamentals/colours/variants';
import { P } from '../../components/Texts/Texts';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { GapContainer, SpaceContainer } from '../../fundamentals/spaces/SpaceContainer';

export interface IBulletProps extends IShadowProps, IGutterProps, Pick<React.HTMLProps<HTMLAnchorElement>, 'onClick'> {
  textMain?: string;
  textSecondary?: string | string[];
  iconName?: MaterialIcon;
  iconType?: MaterialIconType;
  iconVariant?: StatusColour;
}

const BulletContainer = styled(GapContainer)`
  ${({ theme }) => css`
    gap: ${theme.eoraSpaces[EORA_SPACES.LARGE]};
    padding-left: ${theme.eoraSpaces[EORA_SPACES.XSMALL]};
  `};
`;

const StyledIcon = styled(Icon)`
  margin: ${({ theme }) => theme.eoraSpaces.xsmall};
`;

const TextContainer = styled(SpaceContainer)`
  flex-direction: column;
`;

const MainTextContainer = styled(P)``;

const SecondaryTextContainer = styled(P)`
  color: ${({ theme }) => theme.colours.palette.neutral};
`;

export const Bullet: React.FC<IBulletProps> = ({ textMain, textSecondary, iconName, iconVariant, iconType, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Bullet');
  const secondaryTexts = Array.isArray(textSecondary) ? textSecondary : [textSecondary];
  return (
    <BulletContainer {...generateTestId()} {...rest}>
      <StyledIcon
        size={SIZES.XX_SMALL}
        name={iconName ?? MATERIAL_ICONS.CheckCircle}
        type={iconType ?? 'default'}
        variant={iconVariant ?? STATUS_COLOURS.SUCCESS}
      />
      <TextContainer {...generateTestId('TextContainer')}>
        <MainTextContainer gutter={false} textStyle='MEDIUM' textEoraSize='DEFAULT'>
          {textMain}
        </MainTextContainer>
        {secondaryTexts.map((text, key) => (
          <SecondaryTextContainer key={key} gutter={false} textEoraSize='SMALL' textStyle='REGULAR'>
            {text}
          </SecondaryTextContainer>
        ))}
      </TextContainer>
    </BulletContainer>
  );
};
